var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-lazy-image',{attrs:{"src":_vm.src,"alt":_vm.alt,"src-placeholder":"https://s16.picofile.com/file/8421955526/USERAL_logo.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }